import Vue from 'vue'
import appConfig from './AppConfig'
import mapboxgl from 'mapbox-gl'

export class MapboxGLMapper {
  map = undefined
  markers = []
  ScaleControl = undefined
  mapStyle = 'mapbox://styles/mapbox/streets-v11'

  createMap(center, zoom) {
    mapboxgl.accessToken = appConfig.mapboxToken

    let options = {
      container: 'map-box',
      style: this.mapStyle,
      center: center,
      zoom: zoom
    }

    this.map = new mapboxgl.Map(options)

    const showScale = Vue.$storage.get('showScale', false)

    if (showScale) {
      this.addScaleControl()
    }
  }

  setStyle(style) {
    this.map.setStyle(`mapbox://styles/mapbox/${style}`)
  }

  addMarker(
    lng,
    lat,
    displayText,
    iconName = 'mdi-map-marker',
    iconClass = 'blue-darken-3'
  ) {
    var popup = new mapboxgl.Popup({
      anchor: 'top',
      offset: -45,
      closeButton: false
    })
    popup.setText(displayText)

    const marker = new mapboxgl.Marker(
      this.getMarkerElement(iconName, iconClass)
    )
      .setLngLat({ lng, lat })
      .setPopup(popup)
      .addTo(this.map)

    this.markers.push(marker)

    return marker
  }

  removeMarker(marker) {
    if (marker) {
      marker.remove()
      this.markers = this.markers.filter(item => item !== marker)
    }
  }

  removeAllMarkers() {
    this.markers.forEach(marker => {
      marker.remove()
    })

    this.markers = []
  }

  addScaleControl() {
    if (!this.scaleControl) {
      this.scaleControl = new mapboxgl.ScaleControl({
        maxWidth: 80,
        unit: 'imperial'
      })

      this.map.addControl(this.scaleControl, 'bottom-left')
    }
  }

  removeScaleControl() {
    if (this.scaleControl) {
      this.map.removeControl(this.scaleControl)
      this.scaleControl = undefined
    }
  }

  zoomIn() {
    this.map.zoomIn()
  }

  zoomOut() {
    this.map.zoomOut()
  }

  getCenter() {
    return this.map.getCenter()
  }

  getZoom() {
    return this.map.getZoom()
  }

  panTo(coordinates) {
    this.map.panTo(coordinates)
  }

  zoomTo(zoom) {
    this.map.zoomTo(zoom)
  }

  flyTo(options) {
    this.map.flyTo(options)
  }

  fitBounds(bounds) {
    this.map.fitBounds(bounds)
  }

  getBounds() {
    return this.map.getBounds().toArray()
  }

  getMarkerElement(iconName, iconClass) {
    let el = document.createElement('i')
    el.className = `map-marker mdi ${iconName} ${iconClass}`

    return el
  }
}
